import BossModel from "@/models/BossModel";
import PublicImage from "@/models/PublicImage/PublicImage";

export default class Slide extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-widget/photo-slider/slide';

    /**
     *
     * @type {string}
     */
    static entity = 'websiteWidgetPhotoSliderSlides';

    static fields() {
		return {
			id: this.number(null).nullable(),
			website_widget_photo_slider_id: this.number(null).nullable(),
			public_image_id: this.number(null).nullable(),
			created_at: this.attr(null),
			updated_at: this.attr(null),
			rank: this.number(null).nullable(),
            publicImage: this.belongsTo(PublicImage, 'public_image_id'),
		}
	}

    /**
     *
     * @param sliderId
     * @returns {*}
     */
    static fetchByWebsitePageId(sliderId) {
        return this.api()
            .where('website_widget_photo_slider_id', sliderId)
            .with(['publicImage'])
            .get(true);
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    PublicImage(){
        return this.getRelated('publicImage');
    }
}
